import { Link } from 'react-router-dom';

const INTEGRATION_LABELS = {
  gohighlevel: 'Go High Level',
  microsoft_graph: 'Microsoft Teams',
  bitwarden: 'Bitwarden',
  stripe: 'Stripe',
  quickbooks: 'QuickBooks',
  openai: 'OpenAI',
  figma: 'Figma',
  google_analytics: 'Google Analytics',
  se_ranking: 'SE Ranking',
  hosting: 'Hosting monitor',
};

const STATUS_LABELS = {
  full: 'Fully ready',
  partial: 'Partially configured',
  none: 'Not configured',
};

function resolveStatus(item) {
  if (item.status === 'full' || item.status === 'partial' || item.status === 'none') {
    return item.status;
  }

  return item.configured ? 'full' : 'none';
}

function IntegrationStatusIcon({ status }) {
  if (status === 'full') {
    return (
      <span className="integration-status-icon integration-status-icon--ok" aria-hidden>
        <svg viewBox="0 0 16 16" width="12" height="12" fill="none">
          <path
            d="M3.5 8.25L6.5 11.25L12.5 4.75"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    );
  }

  if (status === 'partial') {
    return (
      <span className="integration-status-icon integration-status-icon--partial" aria-hidden>
        <svg viewBox="0 0 16 16" width="12" height="12" fill="none">
          <path
            d="M8 4.5V8.75M8 11.25H8.01"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </span>
    );
  }

  return (
    <span className="integration-status-icon integration-status-icon--missing" aria-hidden>
      <svg viewBox="0 0 16 16" width="10" height="10" fill="none">
        <path d="M4 8H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </span>
  );
}

export function DashboardIntegrationsPanel({ integrations }) {
  if (!integrations?.length) {
    return null;
  }

  const counts = integrations.reduce(
    (acc, item) => {
      const status = resolveStatus(item);
      acc[status] += 1;
      return acc;
    },
    { full: 0, partial: 0, none: 0 },
  );

  return (
    <div className="auth-card flat dashboard-integrations-card" data-tour="dashboard-integrations">
      <div className="dashboard-integrations-head">
        <h3 style={{ margin: 0 }}>Integrations</h3>
        <span className="dashboard-integrations-summary">
          {counts.full} ready
          {counts.partial ? ` · ${counts.partial} partial` : ''}
          {counts.none ? ` · ${counts.none} off` : ''}
        </span>
      </div>

      <ul className="dashboard-integrations-list">
        {integrations.map((item) => {
          const status = resolveStatus(item);

          return (
            <li
              key={item.provider}
              className={`dashboard-integrations-item dashboard-integrations-item--${status}`}
              title={item.hint || STATUS_LABELS[status]}
            >
              <IntegrationStatusIcon status={status} />
              <div className="dashboard-integrations-copy">
                <span className="dashboard-integrations-label">
                  {INTEGRATION_LABELS[item.provider] ?? item.provider}
                </span>
                {status === 'partial' && item.hint ? (
                  <span className="dashboard-integrations-hint">{item.hint}</span>
                ) : null}
              </div>
              <span className="visually-hidden">
                {STATUS_LABELS[status]}
                {item.hint ? ` — ${item.hint}` : ''}
              </span>
            </li>
          );
        })}
      </ul>

      <Link to="/admin/integrations" className="small dashboard-integrations-link">
        Manage integrations →
      </Link>
    </div>
  );
}
